import colors from '@/theme/colors';
import { TContentStatus } from '@/types/Content.types';
import { HStack, Text } from '@chakra-ui/react';
import { getContentStatusLabel, STATUS_COLOR, STATUS_ICON } from './contentLabels';

const ContentStatusBadge = ({ status }: { status?: TContentStatus | null }) => {
  const color = status ? STATUS_COLOR[status] : colors.text.mediumGray;
  const Icon = status ? STATUS_ICON[status] : undefined;
  return (
    <HStack as="span" display="inline-flex" gap="5px" align="center">
      {Icon && <Icon size={14} color={color} />}
      <Text as="span" color={color} fontWeight={700} fontSize="13px" textTransform="uppercase" letterSpacing="0.5px">
        {getContentStatusLabel(status)}
      </Text>
    </HStack>
  );
};

export default ContentStatusBadge;
